var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPerson20 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mobile-size-fms",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-account-box",
    "data-name": "Icon material-account-box",
    d: "M33,17a8,8,0,1,1-8-8A7.989,7.989,0,0,1,33,17ZM9,38.333C9,33,19.667,30.067,25,30.067S41,33,41,38.333V41H9Z",
    transform: "translate(-8.5 -8.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPerson20, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/person-20.2caff9c3.svg";
export { ForwardRef as ReactComponent };